<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 22 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 18V16.8C15 15.1198 15 14.2798 14.673 13.638C14.3854 13.0735 13.9265 12.6146 13.362 12.327C12.7202 12 11.8802 12 10.2 12H5.8C4.11984 12 3.27976 12 2.63803 12.327C2.07354 12.6146 1.6146 13.0735 1.32698 13.638C1 14.2798 1 15.1198 1 16.8V18M15 3L17 5L21 1M11.5 4.5C11.5 6.433 9.933 8 8 8C6.067 8 4.5 6.433 4.5 4.5C4.5 2.567 6.067 1 8 1C9.933 1 11.5 2.567 11.5 4.5Z"
      stroke="#557925"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
